import RefreshButton from '../../common/components/List/RefreshButton.js'
import {refreshTransferList} from './transferListFunctions.js'

export default function RefreshTransferList() {
  return (
    <li
      className="inline-block margin-right-3 tooltip--top"
      data-hint="Refresh the Manufacturing Order list"
    >
      <RefreshButton onClick={() => refreshTransferList()} />
    </li>
  )
}
